import { render, staticRenderFns } from "./DailyReport_Total.vue?vue&type=template&id=13f87d10&"
import script from "./DailyReport_Total.vue?vue&type=script&lang=js&"
export * from "./DailyReport_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports